customElements.get("quick-add-modal") ||
  customElements.define(
    "quick-add-modal",
    class extends ModalDialog {
      constructor() {
        super(),
          (this.modalContent = this.querySelector('[id^="QuickAddInfo-"]')),
          window.addEventListener("keyup", (e) => {
            "ESCAPE" === e.code.toUpperCase() && this.hide();
          });
      }
      hide(e = !1) {
        var t = document.querySelector("cart-drawer");
        t && t.setActiveElement(this.openedBy), (this.modalContent.innerHTML = ""), e && (this.openedBy = null), super.hide(), setTimeout(() => this.remove(), 500);
      }
      show(t) {
        t.setAttribute("aria-disabled", !0),
          t.classList.add("loading"),
          t.querySelector(".loading-overlay__spinner") && t.querySelector(".loading-overlay__spinner").classList.remove("hidden"),
          fetch(t.getAttribute("data-product-url"))
            .then((e) => e.text())
            .then((e) => {
              e = new DOMParser().parseFromString(e, "text/html");
              (this.productElement = e.querySelector('section[id^="MainProduct-"]')),
                this.preventDuplicatedIDs(),
                this.removeDOMElements(),
                this.setInnerHTML(this.modalContent, this.productElement.innerHTML, t),
                window.Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init(),
                window.ProductModel && window.ProductModel.loadShopifyXR(),
                this.updateImageSizes(),
                this.preventVariantURLSwitching(),
                super.show(t);
            })
            .finally(() => {
              t.removeAttribute("aria-disabled"), t.classList.remove("loading"), t.querySelector(".loading-overlay__spinner") && t.querySelector(".loading-overlay__spinner").classList.add("hidden"), sliderQuickAddInit(this);
              if (this.modalContent.querySelector('option[data-disabled-option]') && this.modalContent.querySelector('option[data-disabled-option]').hasAttribute("selected") ) {
                this.modalContent.querySelector('.product-form__submit span').innerHTML = this.modalContent.querySelector('option[data-disabled-option]').innerHTML;
                this.modalContent.querySelector('.product-form__submit').setAttribute('aria-disabled', 'false');
                this.modalContent.querySelector('.product-form__submit').setAttribute('disabled', 'disabled');
              }
            });
      }
      setInnerHTML(e, t, r) {
        (e.innerHTML = t),
          e.querySelectorAll("script").forEach((e) => {
            const t = document.createElement("script");
            Array.from(e.attributes).forEach((e) => {
              t.setAttribute(e.name, e.value);
            }),
              t.appendChild(document.createTextNode(e.innerHTML)),
              e.parentNode.replaceChild(t, e);
          });
        (t = document.createElement("h2")), t.setAttribute("class", "quick-add-modal__title h3"), (t.innerText = theme.quickAddTitle), e.querySelector(".product").prepend(t), (t = document.createElement("a"));
        (t.innerHTML = `<span>${theme.quickviewMore}</span>`),
          t.setAttribute("href", r.getAttribute("data-product-url")),
          t.setAttribute("class", "product__full-details button button--simple_secondary justify-center"),
          e.querySelectorAll(".product__info-column") && e.querySelectorAll(".product__info-column").length,
          e.querySelector(".product-form").appendChild(t);
      }
      removeDOMElements() {
        var e = this.productElement.querySelectorAll(".product-popup"),
          e =
            (e &&
              e.forEach((e) => {
                e.remove();
              }),
            this.productElement.querySelectorAll(".about")),
          e =
            (e &&
              e.forEach((e) => {
                e.remove();
              }),
            this.productElement.querySelector(".share-buttons")),
          e = (e && e.remove(), this.productElement.querySelector(".product__sku")),
          e = (e && e.remove(), this.productElement.querySelector(".breadcrumb")),
          e = (e && e.remove(), this.productElement.querySelector(".product-tags")),
          e = (e && e.remove(), this.productElement.querySelector(".pickup-availability")),
          e = (e && e.remove(), this.productElement.querySelector(".pickup-availability__overlay")),
          e = (e && e.remove(), this.productElement.querySelector("product-modal")),
          e = (e && e.remove(), this.productElement.querySelector(".product__description")),
          e = (e && e.remove(), this.productElement.querySelector(".product__inventory")),
          e = (e && e.remove(), this.productElement.querySelector(".product__media-sublist-outer"));
        e && e.remove();
      }
      preventDuplicatedIDs() {
        const t = this.productElement.dataset.section;
        (this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(t, "quickadd-" + t)),
          this.productElement.querySelectorAll("variant-selects, variant-radios").forEach((e) => {
            e.dataset.originalSection = t;
          });
      }
      preventVariantURLSwitching() {
        this.modalContent.querySelector("variant-radios,variant-selects") && this.modalContent.querySelector("variant-radios,variant-selects").setAttribute("data-update-url", "false");
      }
      updateImageSizes() {
        var e = this.modalContent.querySelector(".product");
        if (e.classList.contains("product--columns")) {
          var r = e.querySelectorAll(".product__media img");
          if (r.length) {
            let t = "(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)";
            e.classList.contains("product--medium") ? (t = t.replace("715px", "605px")) : e.classList.contains("product--small") && (t = t.replace("715px", "495px")), r.forEach((e) => e.setAttribute("sizes", t));
          }
        }
      }
    }
  );
